import FilterListIcon from "@material-ui/icons/FilterList";
import React from "react";
import { Box, IconButton, Popover } from "@material-ui/core";
import { tesaBlue, tesaDarkGrey } from "../../styles/colors";
import CustomDropdownMultiple from "../Input/CustomDropdownMultiple";
import useStyles from "./TableColumnFilterStyles";

interface TestCasesOverviewTableFilterLabelProps {
  filterOptions: string[];
  activeFilters: string[];
  popoverId: string;
  onFilterChange: (data: string[]) => void;
}

const TestCasesOverviewTableFilterLabel = (props: TestCasesOverviewTableFilterLabelProps) => {
  const { activeFilters, onFilterChange, filterOptions } = props;

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    onFilterChange(event.target.value as string[]);
  };

  const open = Boolean(anchorEl);

  const id = open ? props.popoverId : undefined;

  return (
    <>
      <IconButton size="small" onClick={handleClick}>
        <FilterListIcon
          fontSize="inherit"
          style={activeFilters && activeFilters.length > 0 ? { color: tesaBlue } : { color: tesaDarkGrey }}
        />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box className={classes.box}>
          <CustomDropdownMultiple
            chips
            labelText="Filter"
            onChange={handleChange}
            onClose={handleClose}
            options={filterOptions || []}
            value={activeFilters || []}
          />
        </Box>
      </Popover>
    </>
  );
};

export default TestCasesOverviewTableFilterLabel;
